import React from "react";
import { STATUS_PILL } from "../lib/api";

export default function StatusPill({ value, className = "", testid }) {
  const v = value || "none";
  const cfg = STATUS_PILL[v] || STATUS_PILL.none;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${cfg.cls} ${className}`}
    >
      {cfg.label || v}
    </span>
  );
}
